import { Component, ElementRef, HostListener, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { MessageService } from 'src/app/core/services/message.service';
import { AuthenticationService, UserDto } from '../../../core/services/authentication.service';
import { LayoutService } from '../../service/layout.service';

@Component({
    selector: 'app-topbar',
    templateUrl: './topbar.component.html',
    styleUrls: ['./topbar.component.scss'],
    standalone: false
})
export class TopbarComponent implements OnInit {

  @ViewChild('menubutton') menuButton!: ElementRef;
  user: UserDto | undefined;
  userMenuOpen = false;

  constructor(
    public layoutService: LayoutService,
    private authService: AuthenticationService,
    private messageService: MessageService,
    private router: Router
  ) {}

  ngOnInit(): void {
    // Obter informações do usuário logado
    this.authService.$user.subscribe(user => {
      this.user = user;
    });
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    const target = event.target as HTMLElement;
    if (!target.closest('.user-dropdown')) {
      this.userMenuOpen = false;
    }
  }

  getInitials(name?: string): string {
    if (!name) return '';
    return name.trim().split(/\s+/).slice(0, 2)
      .map(p => p[0]?.toUpperCase() || '').join('');
  }

  get isMenuVisible(): boolean {
    if (this.layoutService.isDesktop()) {
      return !this.layoutService.state.staticMenuDesktopInactive;
    }
    return this.layoutService.state.staticMenuMobileActive;
  }

  logout(): void {
 this.authService.signOut()
          .then(() => {
            // O redirecionamento já é feito no serviço de autenticação
          })
          .catch(error => {
            console.error('Erro ao fazer logout:', error);
            this.messageService.add({ 
              severity: 'error', 
              summary: 'Erro', 
              detail: 'Ocorreu um erro ao sair do sistema.' 
            });
          });
  }

  navigateToProfile(): void {
    this.router.navigate(['/admin/profile']);
    this.layoutService.toggleProfileSidebar();
  }

  navigateToSettings(): void {
    this.router.navigate(['/admin/settings']);
    this.layoutService.toggleProfileSidebar();
  }
}
